import React from 'react';
import { Link } from 'react-router-dom';

const BuildTogether = () => {
    return (
        <section className="bg-white 
h-[calc(100vh-80px)] md:h-[calc(100vh-90px)] 
flex items-center">
            <div className="container-x">
                {/* Main Card Container */}
                <div className="relative bg-black overflow-hidden rounded-tr-lg rounded-bl-lg h-full flex items-center">

                    {/* Decorative Circles */}
                    <div className="absolute right-0 bottom-0 pointer-events-none">
                        {/* BIG CIRCLE */}
                        <div className="absolute -right-24 -bottom-24 md:-right-32 md:-bottom-32 lg:-right-48 lg:-bottom-48 w-64 h-64 md:w-[400px] md:h-[400px] lg:w-[500px] lg:h-[500px] border border-white/20 rounded-full"></div>
                        {/* SMALL CIRCLE */}
                        <div className="absolute -right-16 -bottom-16 md:-right-24 md:-bottom-24 lg:-right-36 lg:-bottom-36 w-48 h-48 md:w-[300px] md:h-[300px] lg:w-[400px] lg:h-[400px] border border-white/20 rounded-full"></div>
                    </div>

                    {/* Content Layout */}
                    <div className="relative z-10 w-full px-8 py-16 md:px-16 md:py-20 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-10">

                        {/* Text Column */}
                        <div className="max-w-2xl">
                            <div className="inline-flex flex-col mb-6">
                                <span className="h-[1px] w-full bg-white/40 mb-2"></span>
                                <p className="text-[10px] md:text-[11px] uppercase tracking-[0.4em] text-white/90 font-bold leading-none">
                                    Let's Build Together
                                </p>
                            </div>

                            <h2 className="heading-premium text-white text-[32px] md:text-[54px] lg:text-[62px] leading-[1.1] mb-8">
                                Looking for custom <br />
                                <span className="italic text-brand-gold">packaging solutions?</span>
                            </h2>

                            <p className="text-white/80 font-light text-sm md:text-base leading-relaxed max-w-lg">
                                Share your brief with our design team and we'll craft a sample that matches your vision — in any size, material or finish.
                            </p>
                        </div>

                        {/* Button Column */}
                        <div className="shrink-0">
                            <Link
                                to="/contact"
                                className="group flex items-center justify-center gap-4 bg-brand-gold text-brand-dark px-10 py-5 text-[11px] md:text-[12px] font-bold tracking-[0.2em] transition-all hover:bg-white"
                            >
                                CONTACT US
                                <svg
                                    width="18" height="18"
                                    viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" strokeWidth="2.5"
                                    className="group-hover:translate-x-1 transition-transform"
                                >
                                    <path d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BuildTogether;